module.exports = {"service-contact-title":"Service & Contact","by-email":"Via e-mail","call-customer-service":"Bel met onze zakelijke klantenservice","request-personal-contact":"Vraag een persoonlijk adviesgesprek aan","contact-form":"Aanvraagformulier"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/service-and-contact.json
// module id = 7zhO
// module chunks = 1